var createChainableTypeChecker = function (validate) {
  function checkType(isRequired, props, propName, componentName, location) {
    componentName = componentName || ANONYMOUS;
    if (props[propName] == null) {
      if (isRequired) {
        return new Error(
          ("Required " + " `" + propName + "` was not specified in ") +
          ("`" + componentName + "`.")
        );
      }
      return null;
    } else {
      return validate(props, propName, componentName, location);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
};

/*Is moment js Object*/
var isMoment = function (props, propName, componentName) {
  componentName = componentName || 'ANONYMOUS';

  if (props[propName]) {
    var value = props[propName];
    return moment.isMoment(value)
      ? null
      : new Error('Component "{0}": prop "{1}" should be instance of "Moment"'.format([componentName, propName]));
  }

  return null;
};


module.exports = {
  isMoment: createChainableTypeChecker(isMoment)
};






